import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { memo } from 'react';
import useChartUpdate from '../UseChartUpdate';
var Pane = /*#__PURE__*/memo(function (_ref) {
  var children = _ref.children,
      restProps = _objectWithoutProperties(_ref, ["children"]);

  useChartUpdate(restProps, updatePane, function (chart) {
    return updatePane(chart, {});
  }, false);
  return null;
});

var updatePane = function updatePane(chart, config) {
  chart.update({
    pane: config
  }, false);
};

Pane.displayName = 'Pane';
export default Pane;